module.exports = __webpack_public_path__ + "img/s3-4.0fba113c.jpg";